import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=7a2dfe9e&"
import script from "./ProductAdd.vue?vue&type=script&lang=js&"
export * from "./ProductAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports